import React from 'react'
import './App.scss'
import {CSSTransition} from "react-transition-group";
import ReadOut from './Components/ReadOut'
import SearchBox from './Components/SearchBox'
import HaircareType from './Components/HaircareType'
import Message from './Components/Message'
import { Button } from './Components/Buttons'
import GraphComponent from './Components/GraphComponent'

const MATCH_DECAY = 0
const MATCH_GAIN = 3
const DEFAULT_MATCHED = 1


const { fileTemplateUrl } = window.JMO;
let haircarefinder_data = '';
let haircarefinder_title = '';
if (fileTemplateUrl) {
  haircarefinder_data = fileTemplateUrl.replace('FILENAME', 'haircarefinder-data.json');
  haircarefinder_title = fileTemplateUrl.replace('FILENAME', 'haircarefinder-title.svg');
  
}

const a = Promise.resolve(1).then((err) => {
  throw err
}).catch(() => console.log('err')).then(() => Promise.resolve(2)).catch(() => console.log('abc')).then(() => console.log('abc'))
const JSON_URL = `${haircarefinder_data}`

window.JMOSettings = {
  BREAKPOINT: 960,
  chart: {
    THRESHOLD: 1,
  },
  category: [
    {
      id: 1,
      name: 'シャンプー',
      color: '#9ecbb9',
    },
    {
      id: 2,
      name: 'コンディショナー',
      color: '#dacfbf',
    },
    {
      id: 3,
      name: 'ヘアマスク',
      color: '#e1db7a',
    },
    {
      id: 4,
      name: 'オイル',
      color: '#f1a783',
    },
    {
      id: 5,
      name: 'ミスト',
      color: '#83b4ba',
    },
    {
      id: 6,
      name: 'ミルク',
      color: '#9c8d9e',
    },
    {
      id: 7,
      name: 'スキャルプケア',
      color: '#c6d288',
    },
  ],
  fragrance: [
    {
      id: 'unscented',
      name: '無香',
      scale: 0.9,
    },
    {
      id: 'herb',
      name: 'ハーブ系',
    },
    {
      id: 'floral',
      name: 'フローラル系',
    },
    {
      id: 'citrus',
      name: 'シトラス系',
    },
  ],
  condition: {
    scalp: {
      title: '頭皮の悩み',
      type: 'radio',
      data: ['ノーマル', '乾燥・かゆみ\n（ドライ）', 'ベタつき'],
    },
    quality: {
      title: '髪質',
      type: 'radio',
      data: ['細い/柔らかい', 'ふつう', '太い/固い'],
      label: {
        min: '細い/柔らかい',
        max: '太い/固い',
        middle: 'ふつう',
      },
    },
    damage: {
      title: '髪のダメージ <small>(複数選択可)</small>',
      type: 'button-group',
      data: [
        'カラーやパーマをしている',
        '枝毛、切れ毛が気になる',
        '髪のパサつきが気になる',
        '髪がからまりやすい',
        '髪がうねる、広がる',
      ],
    },
    preference: {
      title: '好みの洗い上がり・使用感',
      type: 'slider',
      min: -2,
      max: 2,
      label: {
        min: 'しっとり',
        max: 'すっきり',
      },
    },
    finish: {
      title: 'なりたい仕上がり <small>(2つまで選択可)</small>',
      type: 'button-group',
      data: ['つやつや', 'さらさら', 'しっとり', 'まとまり', 'ふんわり', 'ハリ・コシ'],
    },
  },
}

function createDefaultState() {
  const defaultState = {}
  Object.keys(window.JMOSettings.condition).forEach(function(key) {
    let value = ''
    const type = window.JMOSettings.condition[key].type
    if (window.JMOSettings.condition[key].defaultValue) {
      value = window.JMOSettings.condition[key].defaultValue
    } else if (type === 'button-group' || type === 'button-sum') {
      value = window.JMOSettings.condition[key].data.map(d => {
        return false
      })
    } else if (type === 'slider') {
      const range = window.JMOSettings.condition[key].max - window.JMOSettings.condition[key].min
      const middle = window.JMOSettings.condition[key].min + ~~(range * 0.5)
      value = middle
    }
    defaultState[key] = value
  })

  return defaultState
}

function filterData(productsDataOriginal, conditionState) {
  let productsData = JSON.parse(JSON.stringify(productsDataOriginal)) // deep copy

  // init matched
  productsData.children.forEach(d => (d.matched = DEFAULT_MATCHED))

  let maxMatched = 0

  Object.keys(conditionState).forEach(currentCondition => {
    const condType = window.JMOSettings.condition[currentCondition].type
    switch (condType) {
      case 'button-group':
        const buttonValues = conditionState[currentCondition]
          .map((d, i) => {
            if (d) {
              return i + 1
            } else {
              return null
            }
          })
          .filter(d => d)

        if (buttonValues.length) {
          productsData.children.map(d => {
            const productValue = d[currentCondition]
            const productValues = Array.isArray(productValue) ? productValue : [productValue]
            const matched = !![productValues, buttonValues].reduce((a, b) => a.filter(c => b.includes(c))).length

            if (matched) {
              d.matched *= MATCH_GAIN
              maxMatched = Math.max(maxMatched, d.matched)
            } else {
              d.matched *= MATCH_DECAY
            }
            return true
          })
        }
        break

      case 'slider':
        const sliderValue = conditionState[currentCondition]
        if (sliderValue) {
          productsData.children.map(prod => {
            const productData = prod[currentCondition]

            const isArrayAndIncludesValue = Array.isArray(productData) && productData.includes(sliderValue)
            const isNumberAndEqual = typeof productData === 'number' && productData === sliderValue

            if (isArrayAndIncludesValue || isNumberAndEqual) {
              prod.matched *= MATCH_GAIN
              maxMatched = Math.max(maxMatched, prod.matched)
            } else {
              prod.matched *= MATCH_DECAY
            }
            return true
          })
        }

        break
      case 'radio':
        const radioValue = conditionState[currentCondition]
        if (radioValue) {
          productsData.children.map(prod => {
            const productData = prod[currentCondition]
            const isArrayAndIncludesValue = Array.isArray(productData) && productData.includes(radioValue)
            const isNumberAndEqual = typeof productData === 'number' && productData === radioValue
            if (isArrayAndIncludesValue || isNumberAndEqual) {
              prod.matched *= MATCH_GAIN
              maxMatched = Math.max(maxMatched, prod.matched)
            } else {
              prod.matched *= MATCH_DECAY
            }
            return true
          })
        }
        break
      default:
    }
  })

  productsData.maxMatched = maxMatched

  return productsData
}

class App extends React.Component {
  constructor(props) {
    super(props)
    this.emptyCond = createDefaultState()
    this.state = {
      single: null,
      show_detail: false,
      productsJSONData: null,
      cond: this.emptyCond,
      // finishTypeFilled: false,
      readyShowType: false,
      showType: false,
    }
    this.originalData = null
  }

  // lifecycle
  componentDidMount() {
    fetch(JSON_URL)
      .then(res => res.json())
      .then(
        result => {
          result.children.map(d => {
            d.matched = 0
            return true
          })

          this.originalData = result

          this.setState({
            isLoaded: true,
            productsJSONData: result,
          })
        },
        error => {
          console.error(error)
          this.setState({
            isLoaded: true,
            error: error.toString(),
          })
        }
      )
  }

  async updateCondition({ key, index, value }) {
    let newCond = JSON.parse(JSON.stringify(this.state.cond))
    if (index !== undefined) {
      newCond[key][index] = value
    } else {
      newCond[key] = value
    }
    await this.setState({
      cond: newCond,
    })
    this.isFilled()
  }
  reset() {
    this.setState({
      cond: this.emptyCond,
      reset: true,
    })
  }
  toggleType() {
    this.setState({
      showType: !this.state.showType,
    })
  }
  matchedItemQuantity() {
    const filtered = filterData(this.state.productsJSONData, this.state.cond)
    return filtered.children.filter(d => d.matched).length
  }
  isFilled() {
    const filled_quality = (!!this.state.cond.quality)
    const filled_finish = this.state.cond.finish.filter(n => n).length >= 1
    const filled_scalp = (!!this.state.cond.scalp)
    this.setState({
      readyShowType: filled_quality && filled_finish && filled_scalp && !!this.matchedItemQuantity(),
    })
  }
  render() {
    if (this.state.error) {
      return <h1 className="error">error: {this.state.error}</h1>
    } else if (!this.state.isLoaded) {
      return <aside id="loading" className={this.state.isLoaded ? 'loaded' : ''}></aside>
    } else {
      return (
        <div id="app">
          <Message
            data={this.matchedItemQuantity()}
          >
          </Message>
          <GraphComponent data={filterData(this.state.productsJSONData, this.state.cond)} reset={this.state.reset} />

          <div id="sidebar">
            <header className="app-header">
              <h1 className="app-title">
                <img src={haircarefinder_title} alt="Hair care finder Your Type"/>
              </h1>
              <p className="app-lead">
                あなたの髪のお悩み、髪質、なりたい髪、
                <br />
                あなたに合う最適なヘアケアが
                <br />
                5つのチェックで見つかります。
              </p>
            </header>

            <SearchBox
              settings={window.JMOSettings.condition}
              cond={this.state.cond}
              showResultButton={this.state.readyShowType}
              onReset={e => this.reset()}
              onChange={({ key, index, value }) => {
                this.updateCondition({ key, index, value })
              }}
              onToggleType={() => {
                this.toggleType()
              }}
            />

            <ReadOut frag={window.JMOSettings.fragrance} category={window.JMOSettings.category} />

            <div className="sidebar-control">
              <Button
                addClass="reset"
                onClick={e => {
                  this.reset()
                }}
              >
                リセットして全てを表示
              </Button>
              <a className="btn btn-back" href={'https://johnmastersorganics.jp/'}>
                公式オンラインスストアへ戻る
              </a>
            </div>
          </div>

          <CSSTransition
            classNames="modal"
            in={this.state.showType}
            timeout={700}
            unmountOnExit>
            <HaircareType
              showType={this.state.showType}
              onClickClose={e => {
                this.toggleType()
              }}
              data={filterData(this.state.productsJSONData, this.state.cond)}
              cond={this.state.cond}
            />
          </CSSTransition>

        </div>
      )
    }
  }
}
export default App
